export default {
    init() {
        this.auctionInnerShowMore();
        this.columnSort();
        this.showMoreInfo();
        this.auctionInnerEditToggle();
        this.auctionInnerWinnerSettingsToggle();
        this.auctionInnerAuctionSettingsToggle();
        this.auctionInnerCounterBidToggle();
        this.hidePopUp();
        this.auctionLotsBidLogToggle();
    },

    hidePopUp(){
        $('.change-date-time-popup').hide();
        $('.change-auction-settings-popup').hide();
        $('.winner-settings-time-popup').hide();
        $('.bidding-popup').hide();
    },

    auctionInnerShowMore() {
        $('.auction-inner-lots-list .show-more').on('click', function () {
            let parentElement = $(this).parent().parent();
            let showElement = parentElement.find('.auctions-list--item-row--log-hidden');
            if (parentElement.hasClass('active')) {
                parentElement.removeClass('active');
                showElement.slideUp(300);
            } else {
                parentElement.addClass('active');
                showElement.slideDown(300);
            }
        });
    },

    columnSort() {
        $('.less-more-sort-col').on('click', function () {
            if ($(this).hasClass('more')) {
                $(this).removeClass('more');
                $(this).addClass('less');
                return;
            }
            if ($(this).hasClass('less')) {
                $(this).removeClass('less');
                $(this).addClass('more');
                return;
            }
        });
    },

    showMoreInfo() {
        $('.auction-inner-lots-list .lots-list--item-row--column.info .content-wrap').on('click', function () {
            $(this).parent().parent().parent().parent().find('.lots-list--item-row--log-hidden').slideToggle(300);
        });
    },

    auctionInnerEditToggle() {
        $('.auction-actions--btn-wrap .auction-actions--btn.edit').on('click', function (e) {
            e.preventDefault();
            let thisDrop = $(this).parent().find('.auction-actions-drop');

            if (thisDrop.hasClass('active')) {
                thisDrop.removeClass('active');
            } else {
                thisDrop.addClass('active');
            }
        });

        $('.auction-time-show').on('click', function () {
            $('.change-date-time-popup').fadeIn(300);
        });

        $('.change-date-time-popup .without-end').on('click', function () {
            if ($('.change-date-time-popup .without-end').is(':checked')) {
                $('.change-date-time-popup .date-and-time-item').removeClass('disabled');
            } else {
                $('.change-date-time-popup .date-and-time-item').addClass('disabled');
            }
        });

        $('.change-date-time-popup .close-popup-button').on('click',function(){
            $('.change-date-time-popup').fadeOut(300);
        });
    },

    auctionInnerWinnerSettingsToggle() {
        $('.winner-settings-show').on('click', function () {
            $('.winner-settings-time-popup').fadeIn(300);
        });

        $('.winner-settings-time-popup .close-popup-button').on('click',function(){
            $('.winner-settings-time-popup').fadeOut(300);
        });
    },

    auctionInnerAuctionSettingsToggle() {
        $('.auction-settings-show').on('click', function () {
            $('.change-auction-settings-popup').fadeIn(300);
        });

        $('.change-auction-settings-popup .close-popup-button').on('click',function(){
            $('.change-auction-settings-popup').fadeOut(300);
        });
    },

    auctionInnerCounterBidToggle() {
        $('.counter-bid-show').on('click', function () {
            $('.bidding-popup').fadeIn(300);
        });


        $('body').on('mousedown', function (e) {
            if ($(e.target).hasClass('bidding-popup ')) {
                $('.bidding-popup').fadeOut(300);
            }
        });
    },

    auctionLotsBidLogToggle(){
        $('.lots-bid-log-row .column:not(.actions)').on('click', function() {
            let row = $(this).closest('tr');
            let packageLink = row.data("lots-log-id");
            if (row.hasClass('active')) {
                row.removeClass('active')
                $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').addClass('hidden');
            } else {
                row.addClass('active')
                $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').removeClass('hidden');
            }
        });
    },

}